import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';

import { DeviceStoreStates, DeviceStoreActions, LocationSubset } from '@era/stores';
import { ModelNameFlags } from '@era/locations-sdk';
import { ModelNamesFilter } from './model-names-filter';
import { PaneComponent } from '../../../core/layout/pane/pane.component';
import { RebootDevicesModalComponent } from './reboot-devices-modal.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-reboot-devices-modal',
  templateUrl: './reboot-devices-modal.container.html',
  styleUrls: ['./reboot-devices-modal.container.scss'],
  imports: [PaneComponent, RebootDevicesModalComponent],
})
export class RebootDevicesModalContainerComponent {
  public readonly rebootDevicesForm: UntypedFormGroup;
  @Input() public locationSubset = LocationSubset.All;
  private readonly modelNames = new Array<ModelNameFlags>();

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly deviceStore: Store<DeviceStoreStates.DeviceState>
  ) {}

  closeModal() {
    this.activeModal.close();
  }

  rebootDevices(modelNamesFilter: ModelNamesFilter) {
    Object.keys(modelNamesFilter).forEach((propertyName) => {
      if (modelNamesFilter[propertyName] === true) {
        this.modelNames.push(propertyName as ModelNameFlags);
      }
    });

    this.deviceStore.dispatch(
      DeviceStoreActions.DeviceModalActions.rebootDevicesRequested({
        locationSubset: this.locationSubset,
        modelNames: new Set(this.modelNames),
      })
    );

    this.activeModal.close();
  }
}
